$(->
  # TEAM > NEW USER

  ## Once existing applicants are loaded, clicking applicant name populates create user form
  $(document).on 'click', '.employee_defaults a', (ev)->
    ev.preventDefault()
    $.ajax({
      url: "/manage/apps/" + $(this).data('id')
      type: "GET"
      dataType: 'json'
      cache: false
      success: (data)->
        $('#app_app_id').val(data.id)
        $('#app_applicant_attributes_firstname').val(data.applicant.firstname)
        $('#app_applicant_attributes_lastname').val(data.applicant.lastname)
        $('#app_applicant_attributes_email').val(data.applicant.email)
        $('#app_applicant_attributes_recent_title').val(data.applicant.recent_title)
    })
    false


)
